import { createSlice } from "@reduxjs/toolkit";

interface EditState {
  tourEdit: boolean;
  id: string;
  optionId: string;
  optionEdit: boolean;
}

const initialState: EditState = {
  tourEdit: false,
  id: "",
  optionId: "",
  optionEdit: false,
};

export const tourEdit = createSlice({
  name: "edit",
  initialState,
  reducers: {
    setTourEdit: (state, action) => {
      state.tourEdit = true;
      state.id = action.payload;
    },
    setOptionEdit: (state, action) => {
      state.tourEdit = true;
      state.optionId = action.payload;
    },
    setOptionEdit2: (state, action) => {
      state.optionEdit = true;
      state.optionId = action.payload;
    },
    resetTourEdit: (state) => {
      state.tourEdit = false;
      state.id = "";
    },
    resetOptionEdit: (state) => {
      state.tourEdit = false;
      state.optionId = "";
    },
  },
});

export const {
  setTourEdit,
  resetTourEdit,
  setOptionEdit,
  resetOptionEdit,
  setOptionEdit2,
} = tourEdit.actions;
export default tourEdit.reducer;
